import { CALL_API } from '../middleware/ApiMiddleware';

export const GET_AUTOMATIC_COLLECTION_LIST_REQUEST = 'GET_AUTOMATIC_COLLECTION_LIST_REQUEST';
export const GET_AUTOMATIC_COLLECTION_LIST_FAILURE = 'GET_AUTOMATIC_COLLECTION_LIST_FAILURE';
export const GET_AUTOMATIC_COLLECTION_LIST_SUCCESS = 'GET_AUTOMATIC_COLLECTION_LIST_SUCCESS';

export const GET_MANUAL_COLLECTION_LIST_REQUEST = 'GET_MANUAL_COLLECTION_LIST_REQUEST';
export const GET_MANUAL_COLLECTION_LIST_FAILURE = 'GET_MANUAL_COLLECTION_LIST_FAILURE';
export const GET_MANUAL_COLLECTION_LIST_SUCCESS = 'GET_MANUAL_COLLECTION_LIST_SUCCESS';

export const DOWNLOAD_MANUAL_COLLECTION_REPORT_REQUEST = 'DOWNLOAD_MANUAL_COLLECTION_REPORT_REQUEST';
export const DOWNLOAD_MANUAL_COLLECTION_REPORT_SUCCESS = 'DOWNLOAD_MANUAL_COLLECTION_REPORT_REQUEST';
export const DOWNLOAD_MANUAL_COLLECTION_REPORT_FAILURE = 'DOWNLOAD_MANUAL_COLLECTION_REPORT_FAILURE';

export const UPDATE_DOWNLOAD_AUTOMATIC_COLLECTION_REPORT_REQUEST =
  'UPDATE_DOWNLOAD_AUTOMATIC_COLLECTION_REPORT_REQUEST';
export const UPDATE_DOWNLOAD_AUTOMATIC_COLLECTION_REPORT_SUCCESS =
  'UPDATE_DOWNLOAD_AUTOMATIC_COLLECTION_REPORT_SUCCESS';
export const UPDATE_DOWNLOAD_AUTOMATIC_COLLECTION_REPORT_FAILURE =
  'UPDATE_DOWNLOAD_AUTOMATIC_COLLECTION_REPORT_FAILURE';

const baseURL = 'xerce/automated-collections';

export const fetchAutomaticCollectionList = (
  listFilters: IAutomaticCollectionListFilters,
  hideLoadingWidget = false
) => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'post',
    body: listFilters,
    authenticated: true,
    types: [
      GET_AUTOMATIC_COLLECTION_LIST_REQUEST,
      GET_AUTOMATIC_COLLECTION_LIST_SUCCESS,
      GET_AUTOMATIC_COLLECTION_LIST_FAILURE,
    ],
    hideLoadingWidget,
  },
});

export const fetchManualCollectionList = (listFilters: IManualCollectionListFilters, hideLoadingWidget = false) => ({
  [CALL_API]: {
    endpoint: 'xerce/manual-collections',
    method: 'get',
    params: {
      ...listFilters,
    },
    authenticated: true,
    types: [GET_MANUAL_COLLECTION_LIST_REQUEST, GET_MANUAL_COLLECTION_LIST_SUCCESS, GET_MANUAL_COLLECTION_LIST_FAILURE],
    hideLoadingWidget,
  },
});

export const downloadManualCollectionsReport = (manualCollectionsReportRequest: IManualCollectionsReportRequest) => ({
  [CALL_API]: {
    endpoint: 'xerce/manual-collections/download',
    method: 'post',
    body: manualCollectionsReportRequest,
    authenticated: true,
    types: [
      DOWNLOAD_MANUAL_COLLECTION_REPORT_REQUEST,
      DOWNLOAD_MANUAL_COLLECTION_REPORT_SUCCESS,
      DOWNLOAD_MANUAL_COLLECTION_REPORT_FAILURE,
    ],
  },
});

export const updateDownloadAutomaticCollectionStatus = (recordId: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${recordId}/download`,
    method: 'put',
    authenticated: true,
    body: {},
    types: [
      UPDATE_DOWNLOAD_AUTOMATIC_COLLECTION_REPORT_REQUEST,
      UPDATE_DOWNLOAD_AUTOMATIC_COLLECTION_REPORT_SUCCESS,
      UPDATE_DOWNLOAD_AUTOMATIC_COLLECTION_REPORT_FAILURE,
    ],
  },
});
